import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientEmployeeDocumentComponent } from './client-employee-document.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClientEmployeeContactRoutingModule } from '../client-employee-contact/client-employee-contact-routing.module';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule, ListBoxAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [ClientEmployeeDocumentComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaskedTextBoxModule,
    NgSelectModule,
    ClientEmployeeContactRoutingModule,
    MyDatePickerModule,
    DropDownListAllModule,
    NgbModule,
    GridModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    ListBoxAllModule,
    NgxUiLoaderModule,
    PdfViewerModule
  ],
  exports:[ClientEmployeeDocumentComponent],
  providers: [ColumnChooserService,, FilterService, PageService, ResizeService]
})
export class ClientEmployeeDocumentModule { }
